import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#c1c7d0"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12",
      class: "st0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#f4f5f7",
      d: "M19.5 12c0-.9-.6-1.7-1.5-1.9-.2-3.1-2.8-5.6-6-5.6S6.2 7 6 10.1c-.9.2-1.5 1-1.5 1.9 0 1 .7 1.8 1.7 2 .6 2.8 3 5.5 5.8 5.5s5.2-2.7 5.8-5.5c1-.2 1.7-1 1.7-2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 16.9c-1 0-2-.7-2.3-1.6q-.15-.45.3-.6t.6.3c.2.6.8 1 1.4 1s1.2-.4 1.4-1c.1-.3.4-.4.6-.3.3.1.4.4.3.6-.3.9-1.3 1.6-2.3 1.6",
      class: "st0"
    }, null, -1)
  ]))]))
}
export default { render: render }